import { Button, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import Iconify from "src/components/Iconify";
import useLocales from "src/hooks/useLocales";
import useResponsive from "src/hooks/useResponsive";

import Context from "../../context";
import useOnRepeatDemo from "./PositionsResult.tsx/hooks/useOnRepeatDemo";

// ----------------------------------------------------------------------

export const DemoTitle = () => {
	const { state } = useContext(Context);

	const isMobile = useResponsive("down", "sm");
	const { translate } = useLocales();

	const { onRepeatDemo } = useOnRepeatDemo();

	return (
		<Stack sx={{ zIndex: 100, px: { lg: 40, sm: 20, xs: 6 }, mt: 4, alignItems: "center" }} gap={2}>
			<Typography color='white' variant={isMobile ? "h2" : "h2"}>
				{translate("result_demo.title")}
			</Typography>
			<Typography
				color='#919EAB'
				variant={isMobile ? "body2" : "body1"}
				maxWidth={590}
				sx={{ ml: 0.5 }}
			>
				{translate("result_demo.description_message", {
					positions: state.demoData?.activePositions.length,
					entityName: state.entity?.name
				})}
			</Typography>
			<Button
				variant='contained'
				onClick={onRepeatDemo}
				startIcon={<Iconify icon='mingcute:repeat-line' />}
				size={isMobile ? "small" : "medium"}
				sx={{ mt: 2 }}
			>
				{translate("Repetir demo")}
			</Button>
		</Stack>
	);
};

export default DemoTitle;
